import Vue from 'vue'
import App from './App.vue'

// import axios from '@/axios/http';
// Vue.prototype.$http = axios

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import router from './router/index.js';

import vuexStore from "@/store/$u.mixin.js"
import store from '@/store/$u.index.js';
Vue.mixin(vuexStore);

import http from '@/axios/http.js'
Vue.use(http, App)
Vue.prototype.$http = http

Vue.prototype.$imgUrl = process.env.VUE_APP_BASE_API + "/stage-api";
// import bootstrapcss from '@/assets/bootstrap/bootstrap.min.css';
// import bootstrapjs from '@/assets/bootstrap/bootstrap.bundle.js';

import utils from '@/utils/utils.js';
// Vue.use(utils, App)
Vue.prototype.$utils = utils

// 字典数据组件----------->main.js
// import DictData from '@/components/DictData'
// // 字典组件挂载到Vue上当做插件使用
// DictData.install()

import _ from 'lodash'
Vue.prototype.$_ = _;

export const vm = new Vue({
	render: h => h(App),
	router,
	store,
	// bootstrapcss,
	// bootstrapjs,
}).$mount('#app')

// 引入请求封装，将app参数传递到配置中
// require('@/axios/http.js')(App)
